import { useState } from 'react';
import { Button } from 'components/common';

interface PasswordResetEmailButtonProps {
  onSend: () => Promise<void>;
}

const PasswordResetEmailButton = ({ onSend }: PasswordResetEmailButtonProps) => {
  const [isSending, setIsSending] = useState(false);

  const handleClick = async () => {
    setIsSending(true);

    try {
      await onSend();
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Button
      disabled={isSending}
      onClick={handleClick}
      testId="send-password-reset-email-btn"
      text="bold"
      variant="primary-dark"
    >
      Send email
    </Button>
  );
};

export default PasswordResetEmailButton;
